export default __webpack_public_path__ + "static/media/10.68434b29.png";